import type { AnalyticsEventType, AnalyticsEventsPage, AnalyticsSummary } from '@creativitas/shared';
import { apiFetch } from '@/lib/api';

/** «Администрирование → Аналитика» (docs/ANALYTICS.md). */

export const ADMIN_ANALYTICS_KEY = ['admin', 'analytics'] as const;

export type AnalyticsFilter = { from?: string; type?: AnalyticsEventType };

const queryString = (filter: AnalyticsFilter): string => {
  const params = new URLSearchParams();
  if (filter.from) params.set('from', filter.from);
  if (filter.type) params.set('type', filter.type);
  const text = params.toString();
  return text ? `?${text}` : '';
};

export const fetchAnalyticsSummary = (filter: AnalyticsFilter): Promise<AnalyticsSummary> =>
  apiFetch<AnalyticsSummary>(`/admin/analytics/summary${queryString({ from: filter.from })}`);

export const fetchAnalyticsEvents = (filter: AnalyticsFilter): Promise<AnalyticsEventsPage> =>
  apiFetch<AnalyticsEventsPage>(`/admin/analytics/events${queryString(filter)}`);

/** Обычная ссылка, а не запрос: файл скачивает браузер, вход — по той же куке. */
export const analyticsExportUrl = (filter: AnalyticsFilter): string =>
  `/api/admin/analytics/events/export${queryString(filter)}`;
